import { blueGrey } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

export default createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#303030',
    },
    secondary: blueGrey,
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#101010',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'inherit',
          },
        },
      },
    },
  },
});
